import { joinUrl, omitUndefinedValues } from '../utils.js'
import { ORDER_TYPES } from '../constants.js'
import { APP_URL } from './constants.js'

export const getWidgetUrl = ({
  analyticUserId,
  fromAmount,
  fromAsset,
  paymentMethod,
  toAsset = [],
  type = ORDER_TYPES.buy,
  url = APP_URL,
} = {}) => {
  if (type !== ORDER_TYPES.buy) {
    throw new Error('Only `buy` orders are accepted')
  }

  const searchParameters = new URLSearchParams(
    omitUndefinedValues({
      analyticUserId,
      amount: fromAmount,
      fromAsset,
      paymentMethodType: paymentMethod,
      toAsset: toAsset[0],
    })
  )

  return joinUrl(url, `?${searchParameters}`)
}
